import createCustomAxios from '../utils/axios';
const http = createCustomAxios();
const httpS = createCustomAxios('https://www.gsrc-web.net/ckidfront');
// 导航接口
export function getNav(params) {
	return http({
		method: 'get',
		url: '/NewCkidIndexController/common/getWebChannelListByUid',
		params,
	});
}

export function getTopMenuList(params) {
	return http({
		method: 'get',
		url: '/NewCkidIndexController/getIndexMenuById',
		params,
	});
}
export function getArticleList(params) {
	return http({
		method: 'get',
		url: '/NewCkidIndexController/docListByMenuId',
		params,
	});
}

export function getCarouselList(num) {
	return http({
		method: 'get',
		url: '/NewCkidIndexController/getLunBoPic?num=' + num,
	});
}
//文章列表
export function docListByMenuId(params) {
	return http({
		method: 'get',
		url: '/NewCkidIndexController/docListByMenuId',
		params,
	});
}
//文章详情
export function getArticleDetail(docId) {
	return http({
		method: 'get',
		url: '/NewCkidIndexController/docByDocId?docId=' + docId,
	});
}

export function getUnderMenuList(params) {
	return http({
		method: 'get',
		url: '/NewCkidIndexController/getAllMenuById',
		params,
	});
}
//搜索页
export function searchDataList(params) {
	return http({
		method: 'get',
		url: '/NewCkidIndexController/indexSearch',
		params,
	});
}
//首页根据父级查子集的栏目带着文章
export function getAlDocsByParentId(params) {
	return http({
		method: 'get',
		url: '/NewCkidIndexController/getAllDocsByParentId',
		params,
	});
}

export function getArticleDetailSouthern(docId) {
	return httpS({
		method: 'get',
		url: '/NewCkidIndexController/docByDocId?docId=' + docId,
	});
}

export function getTopMenuListSouthern(params) {
	return httpS({
		method: 'get',
		url: '/NewCkidIndexController/getIndexMenuById',
		params,
	});
}
//首页根据父级查子集的栏目带着文章
export function getAlDocsByParentIdSouthern(params) {
	return httpS({
		method: 'get',
		url: '/NewCkidIndexController/getAllDocsByParentId',
		params,
	});
}

//文章列表-南方研究中心
export function docListByMenuIdSouthern(params) {
	return httpS({
		method: 'get',
		url: '/NewCkidIndexController/docListByMenuId',
		params,
	});
}
//查询标签-南方研究中心
export function docListTagsSouthern(params) {
	return httpS({
		method: 'get',
		url: '/NewCkidIndexController/getDictSByCatalogId',
		params,
	});
}
// 导航接口
export function getNavSouthern(params) {
	return httpS({
		method: 'get',
		url: '/NewCkidIndexController/common/getWebChannelListByUid',
		params,
	});
}
